export default __webpack_public_path__ + "static/media/info-circle.fa620d36.svg";